import { Component, OnInit, ViewChild } from "@angular/core";
import {
  GetTenderCategories,
  GetTenderCategoryByCode,
  GetTenderStatusDescription,
} from "../utils/tender-utils";
import * as moment from "moment/moment";
import { FormGroup, FormControl } from "@angular/forms";
import { CommonService } from "src/app/common.service";
import { TenderList, TenderCard, MinimumRequirement } from "tender-api";
import { Profile, PaymentMethod } from "profile-api";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalComponent } from "../modal/modal.component";

@Component({
  selector: "app-ongoing-tenders",
  templateUrl: "./ongoing-tenders.component.html",
  styleUrls: ["./ongoing-tenders.component.css"],
})
export class OngoingTendersComponent implements OnInit {
  @ViewChild("unauthorizedModal") unauthorizedModal: ModalComponent;

  tenderCategories = [];

  categoryCode: string;
  location: string;
  tenderId: number;
  pageSize: number = 5;
  pageNumber: number = 0;

  publicTenderCards: Array<TenderCard> = [];
  showMoreTenders: boolean = false;

  searchForm = new FormGroup({
    tenderCategory: new FormControl(null),
    location: new FormControl(null),
  });

  isInvitation = false;
  invitationToken = null;
  profile: Profile = {};

  constructor(
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.commonService
      .getProfile()
      .then((profile: Profile) => {
        console.log("User logged in");
        this.profile = profile;
        if (!profile.registryCompleted) {
          this.unauthorizedModal.open();
        } else {
          window["moment"] = moment;
          this.tenderCategories = GetTenderCategories();

          let storedSearchCategory = GetTenderCategoryByCode(
            localStorage.getItem("SEARCH_CATEGORY")
          );
          let storedSearchLocation = localStorage.getItem("SEARCH_LOCATION");

          if (localStorage.getItem("TENDER_ID") === null) {
            if (storedSearchCategory) {
              this.searchForm.patchValue({
                tenderCategory: storedSearchCategory.code,
              });
            }

            if (storedSearchLocation) {
              this.searchForm.patchValue({ location: storedSearchLocation });
            } else {
              this.searchForm.patchValue({ location: "" });
            }
          } else {
            this.tenderId = Number(localStorage.getItem("TENDER_ID"));
            this.searchForm.patchValue({ tenderCategory: null });
            this.searchForm.patchValue({ location: "" });
          }

          if (
            this.route.snapshot.queryParams["invitationToken"] != undefined &&
            this.route.snapshot.queryParams["tenderId"] != undefined
          ) {
            this.isInvitation = true;
            console.log("Invito: " + this.isInvitation);
            this.commonService
              .getTenderPublicService()
              .publicTenderGet(+this.route.snapshot.queryParams["tenderId"], 1, 0)
              .subscribe((res) => {
                console.log("get tender public by id");
                console.log(res);
                this.publicTenderCards = res.tenders;
                this.invitationToken =
                  this.route.snapshot.queryParams["invitationToken"];
                console.log(
                  "token: " + this.route.snapshot.queryParams["invitationToken"]
                );
              });
          } else {
            console.log("No Invito: " + this.isInvitation);
            this.searchOngoingTenders();
          }
        }
      }).catch((error) => {
        console.log("User not logged in. Redirect to login");
        console.log(error);
        this.router.navigate(["/login"], {
          queryParams: {
            fromOngoingTenders: "yes",
            tenderId: this.route.snapshot.queryParams["tenderId"],
            invitationToken: this.route.snapshot.queryParams["invitationToken"],
          },
        });
      });
  }

  searchOngoingTenders() {
    if (!this.profile.registryCompleted) {
      this.unauthorizedModal.open();
      return;
    }
    this.pageNumber = 0;
    this.publicTenderCards = [];
    console.log("publicTenderCards" + this.publicTenderCards);
    this.categoryCode = this.searchForm.get("tenderCategory").value;
    this.location = this.searchForm.get("location").value;

    if (this.categoryCode) {
      localStorage.setItem("SEARCH_CATEGORY", this.categoryCode);
    } else {
      localStorage.setItem("SEARCH_CATEGORY", null);
    }

    if (this.location) {
      localStorage.setItem("SEARCH_LOCATION", this.location);
    } else {
      localStorage.setItem("SEARCH_LOCATION", "");
    }

    console.log(
      "Category = " + this.categoryCode + "; location = " + this.location
    );

    this.loadOngoingTenders();
  }

  loadOngoingTenders() {
    this.commonService
      .getTenderPublicService()
      .publicTenderGet(
        null,
        this.pageSize,
        this.pageNumber,
        this.categoryCode,
        this.location
      )
      .subscribe(
        (res: TenderList) => {
          console.log("Public tenders: " + JSON.stringify(res));
          this.publicTenderCards = this.publicTenderCards.concat(res.tenders);
          this.showMoreTenders =
            res.paging.pageNumber < res.paging.totalPages - 1;

          localStorage.removeItem("TENDER_ID");
          this.tenderId = null;
          console.log(
            "publicTenderCards" + JSON.stringify(this.publicTenderCards)
          );
        },
        (error) => {
          console.error(error);

          localStorage.removeItem("TENDER_ID");
          this.tenderId = null;
        }
      );
  }

  getTenderStatusDesciption(statusCode: string) {
    return GetTenderStatusDescription(statusCode);
  }

  getFormattedDate(date: string) {
    return moment(date).format("DD-MM-YYYY");
  }

  getCategoryImageUrl(categoryCode: string) {
    return GetTenderCategoryByCode(categoryCode).url;
  }

  getAttachmentList(tender: TenderCard) {
    let attachmentList = [];
    let imageCounter = 1;
    let drawingCounter = 1;
    let otherCounter = 1;

    if (tender.attachments) {
      tender.attachments.forEach((attachment) => {
        let name: string;

        switch (attachment.documentType) {
          case "IMAGE":
            name = "Immagine " + imageCounter;
            imageCounter++;
            break;
          case "DRAWING":
            name = "Disegno " + drawingCounter;
            drawingCounter++;
            break;
          case "OTHER":
            name = "Altro " + otherCounter;
            otherCounter++;
            break;
          default:
            break;
        }

        attachmentList.push({ name: name, url: attachment.documentUrl });
      });
    }

    return attachmentList;
  }

  openAttachmentUrl(attachmentUrl: string) {
    if (attachmentUrl) {
      window.open(attachmentUrl);
    }
  }

  loadMoreOngoingTenders() {
    this.pageNumber = this.pageNumber + 1;
    this.loadOngoingTenders();
  }

  buyParticipation(tenderCard: TenderCard) {
    localStorage.setItem("TENDER_TITLE", tenderCard.title);
    localStorage.setItem("TENDER_DESCRIPTION", tenderCard.description);
    localStorage.setItem("TENDER_CUSTOMER", tenderCard.customer);
    localStorage.setItem("TENDER_TYPE", tenderCard.tenderType);
    localStorage.setItem("TENDER_ID", tenderCard.tenderId.toString());
    this.commonService
      .getProfile()
      .then((profile: Profile) => {
        this.commonService
          .saveProfile(profile)
          .then((pro: Profile) => {
            this.commonService
              .getPaymentMethodService()
              .profilePaymentMethodGet()
              .subscribe(
                (paymentMethod: PaymentMethod) => {
                  if (this.isInvitation) {
                    if (paymentMethod.creditCardName == "Admin activation") {
                      this.router.navigate(["/areariservata"], {
                        queryParams: {
                          tabToLoad: "paymentMethod",
                          fromTender: "yes",
                          tenderId: tenderCard.tenderId,
                          invitationToken: this.invitationToken,
                        },
                      });
                    } else {
                      this.router.navigate(
                        ["/acquistapartecipazioneallagara"],
                        {
                          queryParams: {
                            tenderId: tenderCard.tenderId,
                            invitationToken: this.invitationToken,
                          },
                        }
                      );
                    }
                  } else {
                    if (paymentMethod.creditCardName == "Admin activation") {
                      this.router.navigate(["/areariservata"], {
                        queryParams: {
                          tabToLoad: "paymentMethod",
                          fromTender: "yes",
                          tenderId: tenderCard.tenderId,
                        },
                      });
                    } else {
                      this.router.navigate(
                        ["/acquistapartecipazioneallagara"],
                        {
                          queryParams: { tenderId: tenderCard.tenderId },
                        }
                      );
                    }
                  }

                  //window.open('/acquistapartecipazioneallagara?tenderId=' + tenderCard.tenderId,'_self');
                },
                (error) => {
                  if (this.isInvitation) {
                    this.router.navigate(["/areariservata"], {
                      queryParams: {
                        tabToLoad: "paymentMethod",
                        fromTender: "yes",
                        tenderId: tenderCard.tenderId,
                        invitationToken: this.invitationToken,
                      },
                    });
                  } else {
                    this.router.navigate(["/areariservata"], {
                      queryParams: {
                        tabToLoad: "paymentMethod",
                        fromTender: "yes",
                        tenderId: tenderCard.tenderId,
                      },
                    });
                  }

                  //window.open('/areariservata?tabToLoad=paymentMethod&fromTender=yes&tenderId=' + tenderCard.tenderId,'_self');
                }
              );
          })
          .catch((error) => {
            this.router.navigate(["/areariservata"], {
              queryParams: {
                invitationToken: this.invitationToken,
                tabToLoad: "profile",
                fromTender: "yes",
                tenderId: tenderCard.tenderId,
              },
            });
            //window.open('/areariservata?tabToLoad=profile&fromTender=yes&tenderId=' + tenderCard.tenderId,'_self');
          });
      })
      .catch((error) => {
        console.log("User not logged in. Redirect to login");
        console.log(error);
        this.router.navigate(["/login"], {
          queryParams: {
            invitationToken: this.invitationToken,
            fromTender: "yes",
            tenderId: tenderCard.tenderId,
          },
        });
        //window.open('/login?fromTender=yes&tenderId=' + tenderCard.tenderId,'_self');
      });
  }

  goToNewTender() {
    this.router.navigate(["/creaunagara"]);
    //window.open('/creaunagara','_self');
  }

  unauthorizedModalSubmit() {
    this.router.navigate(['/areariservata'], { queryParams: { tabToLoad: 'profile', fromRestrictedArea: true, returnResource:  'gareincorso'} });
    this.unauthorizedModal.close();
  }
}
